import { Pipe, PipeTransform } from '@angular/core';
import { AttributeDefinitionType } from '../models/attributes/attributeDefinitionType';

@Pipe({
  name: 'customFieldTitle',
})
export class CustomFieldTitlePipe implements PipeTransform {
  transform(definitionType: string, tabName: string): string {
    return definitionType == AttributeDefinitionType.SubField
      ? `${tabName} Sub Fields`
      : `${tabName} Fields`;
  }
}
